import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const DateIcon = ({tintColor = '#001533', ...props}) => {
  return (
    <Svg
      width={18}
      height={20}
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M17 8V5a2 2 0 00-2-2H3a2 2 0 00-2 2v3m16 0v9a2 2 0 01-2 2H3a2 2 0 01-2-2V8m16 0H1m4-7v4m8-4v4"
        stroke={tintColor}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </Svg>
  );
};

export default DateIcon;
